import { Box, Button, Grid, TextFieldController } from '@alice-financial/pretext-ui'
import React from 'react'
import { Control } from 'react-hook-form'
import { FormattedMessage, useIntl } from 'react-intl'

type LoginFormValues = {
  requestCodeTarget: string
  verificationCode: string
}

type RequestCodeFormProps = {
  control: Control<LoginFormValues>
  onSubmit: () => void
  isFetching: boolean
  isEmailAddress: (input: string) => boolean
  isPhoneNumber: (input: string) => boolean
}

/**
 * Pure component for the initial request code form
 * Handles both phone number and email address input
 */
export const RequestCodeForm: React.FC<RequestCodeFormProps> = ({
  control,
  onSubmit,
  isFetching,
  isEmailAddress,
  isPhoneNumber,
}) => {
  const intl = useIntl()

  return (
    <Box mb={3} component="form" onSubmit={onSubmit}>
      <Grid container spacing={2}>
        <Grid size={12}>
          <TextFieldController
            control={control}
            name="requestCodeTarget"
            label={<FormattedMessage id="auth.login.phone_or_email_label" />}
            placeholder={intl.formatMessage({ id: 'auth.login.phone_or_email_placeholder' })}
            required
            fullWidth
            autoComplete="tel email"
            rules={{
              validate: (value) => {
                const trimmed = value.trim()
                if (isEmailAddress(trimmed) || isPhoneNumber(trimmed)) {
                  return true
                }
                return intl.formatMessage({ id: 'auth.login.phone_or_email_validation' })
              },
            }}
          />
        </Grid>
      </Grid>
      <Grid container justifyContent="center">
        <Box component={Grid} size={{ xs: 12, sm: 6 }} mt={3} mb={3}>
          <Button variant="contained" type="submit" fullWidth disabled={isFetching}>
            <FormattedMessage id="auth.login.do_login" />
          </Button>
        </Box>
      </Grid>
    </Box>
  )
}
